import { openDB } from 'idb';

const DB_NAME = 'wyrm_audio_v1';
const STORE_SESSIONS = 'sessions';
const STORE_CHUNKS = 'chunks';

export const initAudioDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_SESSIONS)) {
        db.createObjectStore(STORE_SESSIONS, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(STORE_CHUNKS)) {
        const chunkStore = db.createObjectStore(STORE_CHUNKS, { keyPath: 'id', autoIncrement: true });
        chunkStore.createIndex('by_session', 'sessionId');
      }
    },
  });
};

export const startLocalSession = async (sessionId) => {
  const db = await initAudioDB();
  await db.put(STORE_SESSIONS, {
    id: sessionId,
    startTime: Date.now(),
    status: 'recording',
  });
};

export const saveAudioChunk = async (sessionId, blob, seq) => {
  const db = await initAudioDB();
  await db.add(STORE_CHUNKS, { sessionId, blob, seq });
};

export const finishLocalSession = async (sessionId) => {
  const db = await initAudioDB();
  const tx = db.transaction(STORE_SESSIONS, 'readwrite');
  const session = await tx.store.get(sessionId);
  if (session) {
    session.status = 'completed';
    await tx.store.put(session);
  }
  await tx.done;
};

export const recoverRecordingBlob = async (sessionId) => {
  const db = await initAudioDB();
  const chunks = await db.getAllFromIndex(STORE_CHUNKS, 'by_session', sessionId);
  chunks.sort((a, b) => a.seq - b.seq);
  return new Blob(chunks.map((c) => c.blob), { type: 'audio/webm' });
};

export const findInterruptedSessions = async () => {
  const db = await initAudioDB();
  const all = await db.getAll(STORE_SESSIONS);
  return all.filter((s) => s.status === 'recording');
};
